import { motion } from "framer-motion";
import { AlertTriangle, Clock3, Workflow } from "lucide-react";

const CARDS = [
  {
    icon: AlertTriangle,
    title: "Leads getting lost",
    desc: "Inquiries from ads, referrals, and forms slip through the cracks before anyone replies.",
    glow: "glow-violet",
    accent: "text-[#8B5CF6]",
  },
  {
    icon: Clock3,
    title: "Manual follow-ups wasting time",
    desc: "Your team copy-pastes replies, re-types info, and chases leads one-by-one all day.",
    glow: "glow-blue",
    accent: "text-[#007AFF]",
  },
  {
    icon: Workflow,
    title: "Growth creating chaos",
    desc: "More leads mean more spreadsheets, missed messages, and broken handoffs.",
    glow: "glow-cyan",
    accent: "text-[#00F0FF]",
  },
];

export default function ProblemSection() {
  return (
    <section id="problem" className="relative py-24 sm:py-32 overflow-hidden">
      {/* Background moving marquee */}
      <div className="absolute inset-0 -z-0 overflow-hidden pointer-events-none opacity-[0.06]">
        <div className="marquee-track whitespace-nowrap font-display text-[14vw] leading-none text-white">
          {Array.from({ length: 2 }).map((_, n) => (
            <span key={`marquee-${n}`} className="px-8">Manual. Slow. Messy.&nbsp;·&nbsp;Manual. Slow. Messy.&nbsp;·&nbsp;</span>
          ))}
        </div>
      </div>

      <div className="relative max-w-7xl mx-auto px-6">
        <div className="max-w-3xl mb-16">
          <p className="text-xs uppercase tracking-[0.25em] text-[#00F0FF] mb-4" data-testid="problem-kicker">The Problem</p>
          <h2 className="font-display text-4xl sm:text-5xl font-medium text-white leading-tight" data-testid="problem-heading">
            You're not lacking effort. <span className="text-white/50">You're lacking systems.</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {CARDS.map((c, i) => (
            <motion.div
              key={c.title}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.6, delay: i * 0.12, ease: [0.2, 0.8, 0.2, 1] }}
              whileHover={{ y: -6 }}
              className={`glass-card p-8 relative overflow-hidden group ${c.glow}`}
              data-testid={`problem-card-${i}`}
            >
              <div className="absolute -top-10 -right-10 w-40 h-40 rounded-full bg-white/[0.02] blur-2xl group-hover:bg-white/[0.04] transition" />
              <c.icon className={`${c.accent} mb-6`} size={28} />
              <h3 className="font-display text-2xl font-medium text-white mb-3">{c.title}</h3>
              <p className="text-white/60 leading-relaxed">{c.desc}</p>
              <div className="mt-6 text-xs uppercase tracking-[0.2em] text-white/30">0{i + 1} / 03</div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
